import * as yup from "yup"

const validations=yup.object().shape({
	name:yup.string().required("Adınızı daxil edin"),
	surname:yup.string().required("Soyadınızı daxil edin"),
	email:yup.string().email("Email adresinizi düzgün daxil edin").required("Email adresinizi daxil edin"),
	number:yup.number("Telefon nömrəsi daxil edin").required("Telefon nömrəsi daxil edin").positive().integer(),
})

export default validations